const mjmlTemplate = `<mjml>
  <mj-head>
    <mj-attributes>
      <mj-all font-family="Inter, Arial, sans-serif" color="#3b4c56" />
      <mj-text font-size="15px" line-height="1.6" padding="0" />
      <mj-section padding="0" />
      <mj-column padding="0" />
    </mj-attributes>
    <mj-preview>{{preheaderText}}</mj-preview>
    <mj-style inline="inline">
      .markdown p + p { margin-top: 10px; }
      .markdown ul, .markdown ol { margin: 10px 0; padding-left: 20px; }
      .markdown li + li { margin-top: 6px; }
      .markdown a:not(.editorial-pill-cta-link) { color: inherit; text-decoration: underline; }
      .markdown strong { font-weight: 600; }
      .markdown em { font-style: italic; }
      .legal a { color: inherit !important; text-decoration: underline; }
      .legal-links a { cursor: pointer; }
      .social-icon {
        width: 30px !important; height: 30px !important; border-radius: 30px !important;
        background-color: rgba(255,255,255,0.7); display: inline-block;
      }
      .footer-name-address { opacity: .8; font-size: 12px; }
      .footer-name-address p { font-size: 12px !important; margin: 0 0 4px 0; }
      .section-kicker div {
        font-size: 10px !important;
        letter-spacing: 0.14em !important;
        text-transform: uppercase !important;
        color: #888888 !important;
        font-weight: 600 !important;
      }
      .gallery-caption div {
        font-size: 12px !important;
        line-height: 1.4 !important;
        color: #3b4c56 !important;
        text-align: center !important;
      }
      .personal-block div { text-align: left !important; color: #3b4c56 !important; }
      .quote-text div {
        font-size: 16px !important;
        line-height: 1.5 !important;
        font-style: italic !important;
        color: #111827 !important;
      }
      .quote-author div {
        font-size: 12px !important;
        color: #888888 !important;
      }
      .experience-title div {
        font-size: 15px !important;
        font-weight: 600 !important;
        color: #000000 !important;
        text-align: center !important;
      }
      .experience-desc div {
        font-size: 13px !important;
        line-height: 1.5 !important;
        color: #3b4c56 !important;
        text-align: center !important;
      }
      .experience-image img {
        display: block !important;
        width: 100% !important;
        max-width: 160px !important;
        height: auto !important;
        margin: 0 auto !important;
      }
      .lifestyle-image img {
        display: block !important;
        width: 100% !important;
        height: auto !important;
        border-radius: 4px;
      }
      .display-title-serif div {
        font-family: Georgia, 'Times New Roman', serif !important;
        font-size: 28px !important;
        line-height: 1.25 !important;
        font-weight: 400 !important;
        color: #182852 !important;
        text-align: center !important;
      }
      .feature-block .markdown h2,
      .feature-block .markdown h3 {
        font-family: Georgia, 'Times New Roman', serif !important;
        font-size: 22px !important;
        line-height: 1.3 !important;
        font-weight: 400 !important;
        color: #111827 !important;
        margin: 0 0 10px 0 !important;
      }
      .text-link-arrow a {
        color: #182852 !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        text-decoration: underline !important;
        text-underline-offset: 3px !important;
      }
      .text-link-arrow-empty {
        display: none !important;
        max-height: 0 !important;
        overflow: hidden !important;
        font-size: 0 !important;
        line-height: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
      }
      .discover-tile-label div {
        font-size: 13px !important;
        line-height: 1.4 !important;
        color: #3b4c56 !important;
        text-align: center !important;
        padding-top: 8px !important;
      }
      .discover-tile-image img {
        display: block !important;
        width: 100% !important;
        height: auto !important;
        border-radius: 2px;
      }
      .amenity-title div {
        font-size: 11px !important;
        letter-spacing: 0.12em !important;
        text-transform: uppercase !important;
        font-weight: 600 !important;
        color: #111827 !important;
        text-align: center !important;
        padding-top: 10px !important;
      }
      .amenity-image img {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
        border-radius: 2px;
      }
      .discover-link a {
        display: inline-block !important;
        width: 100% !important;
        box-sizing: border-box !important;
        text-align: center !important;
        padding: 10px 16px !important;
        border: 1px solid #d7d8df !important;
        color: #3b4c56 !important;
        text-decoration: none !important;
        font-size: 14px !important;
        margin-bottom: 8px !important;
      }
      .header-tagline-script div {
        font-family: Georgia, 'Times New Roman', serif !important;
        font-size: 26px !important;
        font-style: italic !important;
        color: #182852 !important;
        text-align: center !important;
        line-height: 1.2 !important;
      }
      .header-tagline-sans div {
        font-size: 10px !important;
        letter-spacing: 0.22em !important;
        text-transform: uppercase !important;
        color: #3b4c56 !important;
        text-align: center !important;
        padding-top: 6px !important;
      }
      .arch-image img {
        border-radius: 280px 280px 0 0 !important;
        display: block !important;
        width: 100% !important;
        height: auto !important;
      }
      .editorial-hero-image img {
        display: block !important;
        width: 100% !important;
        height: auto !important;
        border-radius: 0 !important;
      }
      .editorial-experiences-title div {
        font-family: Georgia, 'Times New Roman', serif !important;
        font-size: 30px !important;
        line-height: 1.25 !important;
        font-weight: 400 !important;
        color: #182852 !important;
        text-align: center !important;
      }
      .editorial-story-copy div,
      .editorial-story-copy p {
        color: #3b4c56 !important;
        text-align: center !important;
      }
      .editorial-pill-cta {
        text-align: center !important;
      }
      .editorial-pill-cta div {
        text-align: center !important;
      }
      .editorial-pill-cta-cell {
        border: 1px solid {{ctaBackgroundColor}} !important;
        border-radius: 999px !important;
        background-color: #ffffff !important;
        padding: 12px 36px !important;
        text-align: center !important;
      }
      .editorial-pill-cta-link {
        color: {{ctaTextColor}} !important;
        text-decoration: none !important;
        font-family: Inter, Arial, sans-serif !important;
        font-size: 13px !important;
        font-weight: 600 !important;
        letter-spacing: 0.08em !important;
        display: inline-block !important;
        line-height: 1.2 !important;
        white-space: nowrap !important;
      }
      .markdown a.editorial-pill-cta-link,
      .editorial-pill-cta .editorial-pill-cta-link,
      .mjml-cta-story .editorial-pill-cta-link,
      .mjml-cta-story .editorial-pill-cta-link-inner,
      td.mjml-cta-story a.editorial-pill-cta-link {
        color: {{ctaTextColor}} !important;
        text-decoration: none !important;
      }
      .editorial-pill-cta-link-inner {
        border: none !important;
        padding: 0 !important;
        background-color: transparent !important;
        border-radius: 0 !important;
        color: {{ctaTextColor}} !important;
      }
      .editorial-pill-cta-bulletproof {
        border-collapse: separate !important;
        border-spacing: 0 !important;
        margin-left: auto !important;
        margin-right: auto !important;
      }
      .editorial-story-image td {
        text-align: center !important;
      }
      .editorial-story-image img {
        max-width: 440px !important;
        width: 100% !important;
        height: auto !important;
        display: block !important;
        margin: 0 auto !important;
        border-radius: 220px 220px 0 0 !important;
        padding-bottom: 4px !important;
      }
      .editorial-footer-social td {
        text-align: right !important;
        vertical-align: middle !important;
      }
      .editorial-footer-social a {
        text-decoration: none !important;
        display: inline-block !important;
      }
      .editorial-footer-legal div,
      .editorial-footer-legal p {
        color: #ffffff !important;
        font-size: 12px !important;
        line-height: 1.65 !important;
        text-align: center !important;
        margin: 0 0 10px 0 !important;
      }
      .editorial-footer-legal a {
        color: #ffffff !important;
        text-decoration: underline !important;
      }
      .editorial-footer-divider p {
        border-color: rgba(255, 255, 255, 0.55) !important;
      }
      .hero-overlay-text div {
        font-family: Georgia, 'Times New Roman', serif !important;
        font-size: 28px !important;
        font-style: italic !important;
        color: #182852 !important;
        text-align: center !important;
        padding: 12px 0 0 0 !important;
      }
      .navy-footer-text div, .navy-footer-text p {
        color: #ffffff !important;
        font-size: 12px !important;
        line-height: 1.5 !important;
      }
      .navy-footer-text a {
        color: #ffffff !important;
        text-decoration: underline !important;
      }
      .editorial-footer-top .navy-footer-text div,
      .editorial-footer-top .navy-footer-text p {
        word-break: normal !important;
        overflow-wrap: anywhere !important;
      }
      @media only screen and (max-width: 480px) {
        .editorial-footer-top .mj-column-per-50,
        .editorial-footer-top .mj-column-per-52,
        .editorial-footer-top .mj-column-per-58,
        .editorial-footer-top .mj-column-per-48,
        .editorial-footer-top .mj-column-per-42 {
          width: 100% !important;
          max-width: 100% !important;
        }
        .editorial-footer-social td {
          text-align: center !important;
          padding-top: 18px !important;
        }
        .editorial-footer-top .navy-footer-text {
          text-align: center !important;
        }
      }
      .fine-print div {
        font-size: 11px !important;
        line-height: 1.5 !important;
        color: #6b7280 !important;
        font-style: italic !important;
      }
      .resort-footer-logo img {
        width: 72px !important;
        height: auto !important;
        margin: 0 auto !important;
        display: block !important;
      }
      .gallery-row-four img {
        display: block !important;
        width: 100% !important;
        height: auto !important;
      }
      .resort-invite-title div {
        font-family: Georgia, 'Times New Roman', serif !important;
        font-size: 32px !important;
        line-height: 1.2 !important;
        font-weight: 400 !important;
        color: #2b2b2b !important;
        text-align: center !important;
      }
      .resort-invite-body div,
      .resort-invite-body p {
        color: #3b3b3b !important;
        text-align: center !important;
      }
      .resort-invite-body a {
        color: #1e5a8a !important;
        text-decoration: underline !important;
      }
      .resort-discover-image img {
        display: block !important;
        width: 100% !important;
        height: auto !important;
      }
      .resort-discover-title div {
        font-family: Georgia, 'Times New Roman', serif !important;
        font-size: 30px !important;
        line-height: 1.25 !important;
        font-weight: 400 !important;
        color: #2b2b2b !important;
        text-align: center !important;
      }
      .resort-discover-intro div {
        font-size: 15px !important;
        line-height: 1.65 !important;
        color: #4a4a4a !important;
        text-align: center !important;
      }
      .resort-ghost-button-wrap {
        vertical-align: top !important;
      }
      .resort-ghost-button-cell {
        border: 1px solid #9ca3af !important;
      }
      .resort-ghost-button-cell a {
        color: #4a5563 !important;
        text-decoration: none !important;
        font-family: Inter, Arial, sans-serif !important;
        font-size: 11px !important;
        font-weight: 600 !important;
        letter-spacing: 0.1em !important;
        text-transform: uppercase !important;
        display: block !important;
        line-height: 1.2 !important;
      }
      .resort-footer-contact div,
      .resort-footer-contact a {
        font-size: 14px !important;
        line-height: 1.5 !important;
        text-align: center !important;
      }
      .resort-footer-address div {
        font-size: 12px !important;
        line-height: 1.5 !important;
        color: #6b7280 !important;
        text-align: center !important;
      }
      .resort-header-logo img {
        width: auto !important;
        max-width: 160px !important;
        height: auto !important;
        max-height: 120px !important;
        margin: 0 auto !important;
        display: block !important;
      }
      .resort-footer-emblem img {
        width: auto !important;
        max-width: 140px !important;
        height: auto !important;
        max-height: 120px !important;
        margin: 0 auto !important;
        display: block !important;
      }
      .resort-footer-legal a {
        color: #2b2b2b !important;
        text-decoration: underline !important;
        font-size: 12px !important;
      }
      @media only screen and (max-width: 480px) {
        .experience-col, .gallery-col, .split-col, .social-quote-col, .social-photo-col {
          width: 100% !important;
          max-width: 100% !important;
        }
        .zigzag-image-col, .zigzag-text-col {
          width: 100% !important;
          max-width: 100% !important;
          display: block !important;
        }
      }

    </mj-style>
  </mj-head>
  <mj-body background-color="#EEF1F7" width="680px">
    <mj-wrapper border="1px solid #D7D8DF" padding="0">

      <mj-section background-color="{{headerBgColor}}" padding="28px 30px 0" css-class="mjml-header">
        <mj-column>
          <mj-image src="{{logoUrl}}" alt="Logo" align="center" padding="0 0 12px 0" width="{{logoWidth}}" height="{{logoHeight}}" css-class="mjml-logo" />
          <mj-text css-class="header-tagline-script" padding="0">{{headerTaglineScript}}</mj-text>
          <mj-text css-class="header-tagline-sans" padding="0 0 8px 0">{{headerTaglineSans}}</mj-text>
        </mj-column>
      </mj-section>
      <mj-section padding="0" css-class="mjml-hero" background-color="#FFFFFF">
        <mj-column>
          <mj-image src="{{heroImgUrl}}" alt="Hero" padding="0" href="{{heroImageLinkUrl}}" fluid-on-mobile="true" css-class="editorial-hero-image" />
        </mj-column>
      </mj-section>
      <mj-section padding="36px 40px 12px" css-class="mjml-body" background-color="#FFFFFF">
        <mj-column>
          <mj-text css-class="display-title-serif" padding="0 0 16px 0" align="center">{{emailTitle}}</mj-text>
          <mj-text css-class="markdown" padding="0" line-height="1.65" font-size="16px" align="center">
            <!-- bodyHtml -->
          </mj-text>
          
          <mj-text css-class="mjml-cta editorial-pill-cta" align="center" color="{{ctaTextColor}}" padding="16px 0 40px 0">
            <a href="{{ctaUrl}}" class="editorial-pill-cta-link" style="display:inline-block;border:1px solid {{ctaBackgroundColor}};border-radius:999px;padding:12px 36px;color:{{ctaTextColor}} !important;background-color:#ffffff;text-decoration:none;font-family:Inter,Arial,sans-serif;font-size:13px;font-weight:600;letter-spacing:0.08em;line-height:1.2;white-space:nowrap;">{{ctaText}}</a>
          </mj-text>
        </mj-column>
      </mj-section>
      <mj-section padding="36px 40px 28px" css-class="mjml-experiencesIntro" background-color="#FFFFFF">
        <mj-column>
          <mj-text css-class="editorial-experiences-title" align="center" padding="0">{{featuresSectionTitle}}</mj-text>
        </mj-column>
      </mj-section>
      
      <mj-section padding="8px 40px 0" background-color="#FFFFFF" css-class="mjml-col1">
        <mj-column>
          <mj-image width="440px" css-class="arch-image editorial-story-image" src="{{col1Image}}" alt="Story" padding="0 0 16px 0" href="{{col1ImageLinkUrl}}" />
          <mj-text css-class="markdown feature-block editorial-story-copy" padding="0 0 12px 0" line-height="1.65" font-size="15px" align="center">
            <!-- col1Html -->
          </mj-text>
          
          <mj-text css-class="mjml-cta-story editorial-pill-cta" align="center" color="{{ctaTextColor}}" padding="16px 0 40px 0">
            <a href="{{col1LinkUrl}}" class="editorial-pill-cta-link" data-editorial-story-button="col1" style="display:inline-block;border:1px solid {{ctaBackgroundColor}};border-radius:999px;padding:12px 36px;color:{{ctaTextColor}} !important;background-color:#ffffff;text-decoration:none;font-family:Inter,Arial,sans-serif;font-size:13px;font-weight:600;letter-spacing:0.08em;line-height:1.2;white-space:nowrap;">{{col1LinkText}}</a>
          </mj-text>
        </mj-column>
      </mj-section>
      
      <mj-section padding="8px 40px 0" background-color="#FFFFFF" css-class="mjml-col2">
        <mj-column>
          <mj-image width="440px" css-class="arch-image editorial-story-image" src="{{col2Image}}" alt="Story" padding="0 0 16px 0" href="{{col2ImageLinkUrl}}" />
          <mj-text css-class="markdown feature-block editorial-story-copy" padding="0 0 12px 0" line-height="1.65" font-size="15px" align="center">
            <!-- col2Html -->
          </mj-text>
          
          <mj-text css-class="mjml-cta-story editorial-pill-cta" align="center" color="{{ctaTextColor}}" padding="16px 0 40px 0">
            <a href="{{col2LinkUrl}}" class="editorial-pill-cta-link" data-editorial-story-button="col2" style="display:inline-block;border:1px solid {{ctaBackgroundColor}};border-radius:999px;padding:12px 36px;color:{{ctaTextColor}} !important;background-color:#ffffff;text-decoration:none;font-family:Inter,Arial,sans-serif;font-size:13px;font-weight:600;letter-spacing:0.08em;line-height:1.2;white-space:nowrap;">{{col2LinkText}}</a>
          </mj-text>
        </mj-column>
      </mj-section>
      
      <mj-section padding="8px 40px 56px" background-color="#FFFFFF" css-class="mjml-col3">
        <mj-column>
          <mj-image width="440px" css-class="arch-image editorial-story-image" src="{{col3Image}}" alt="Story" padding="0 0 16px 0" href="{{col3ImageLinkUrl}}" />
          <mj-text css-class="markdown feature-block editorial-story-copy" padding="0 0 12px 0" line-height="1.65" font-size="15px" align="center">
            <!-- col3Html -->
          </mj-text>
          
          <mj-text css-class="mjml-cta-story editorial-pill-cta" align="center" color="{{ctaTextColor}}" padding="16px 0 40px 0">
            <a href="{{col3LinkUrl}}" class="editorial-pill-cta-link" data-editorial-story-button="col3" style="display:inline-block;border:1px solid {{ctaBackgroundColor}};border-radius:999px;padding:12px 36px;color:{{ctaTextColor}} !important;background-color:#ffffff;text-decoration:none;font-family:Inter,Arial,sans-serif;font-size:13px;font-weight:600;letter-spacing:0.08em;line-height:1.2;white-space:nowrap;">{{col3LinkText}}</a>
          </mj-text>
        </mj-column>
      </mj-section>
      <mj-section padding="36px 36px 24px" css-class="mjml-footer editorial-footer-top" background-color="{{footerAccentColor}}">
        <mj-column width="52%" vertical-align="middle">
          <mj-text css-class="navy-footer-text" align="left" padding="0">
            <p style="margin:0 0 4px 0;font-weight:600;">{{hotelName}}</p>
            <p style="margin:0 0 4px 0;">{{hotelAddress}}</p>
            <p style="margin:0 0 4px 0;">{{hotelCityStateZip}}</p>
            <p style="margin:0;"><a href="tel:{{hotelPhone}}" style="color:#ffffff;text-decoration:underline;">{{hotelPhone}}</a></p>
          </mj-text>
        </mj-column>
        <mj-column width="48%" vertical-align="middle">
          <mj-table css-class="editorial-footer-social" align="right" padding="0">
            <tr>
              <td style="text-align:right;white-space:nowrap;vertical-align:middle;">
                <!-- socialMediaLinksHtml -->
              </td>
            </tr>
          </mj-table>
        </mj-column>
      </mj-section>
      <mj-section padding="0 36px 36px" css-class="mjml-footer editorial-footer-bottom" background-color="{{footerAccentColor}}">
        <mj-column>
          <mj-divider css-class="editorial-footer-divider" border-width="1px" border-color="rgba(255,255,255,0.55)" padding="0 0 24px 0" />
          <mj-text css-class="editorial-footer-legal markdown" align="center" padding="0" font-size="12px" color="#ffffff">
            <!-- finePrintHtml -->
          </mj-text>
        </mj-column>
      </mj-section>
    </mj-wrapper>
  </mj-body>
</mjml>`

export default mjmlTemplate
